import React, {useEffect, useState} from 'react';
import {IChatDataProps} from "./ChatComponent";
import {whatsAppClient} from '../../common'
import {useMutation, useQuery} from "@apollo/client";
import {
    GET_WHATSAPP_CONVERSATION,
    WHATSAPP_SEND_MESSAGE,
    MARK_AS_READ,
    GET_WHATSAPP_PROFILE_BY_NUMBER, ASSIGN_WHATSAPP_PROFILE_TO_USER
} from "../../screen/TicketListingScreen/query";
import {SPINNY_WEB_TOKEN} from '../../common';
import {getLoggedInUserName} from "../../screen/TicketListingScreen/helper";
import {getSanitiseNumber} from "../helper";
import { toast } from "react-toastify";
import {pusher} from "../pusher";

interface IWhatsAppDataComponent {
    phoneNumber: string;
    chatBox: (messageData: IChatDataProps) => JSX.Element;
}

const WhatsAppDataComponent = (props: IWhatsAppDataComponent) => {
    const {chatBox, phoneNumber} = props;
    const [loadingMore, setLoadingMore] = useState(false);
    const [loadingState, setLoadingState] = useState(true);
    const [errorState, setErrorState] = useState(null);
    const [isAssignToMeVisible, setIsAssignToMeVisible] = useState(false);
    const userName = getLoggedInUserName();
    const [newWhatsAppMessage, setNewWhatsAppMessage] = useState([]);
    toast.configure();

    const {data: profileData, loading: profileLoading, refetch: profileRefetch, fetchMore: profileFetchMore, error: profileError} = useQuery(GET_WHATSAPP_PROFILE_BY_NUMBER, {
        client: whatsAppClient,
        variables: {
            phoneNumber: phoneNumber
        },
        fetchPolicy: 'network-only'
    });

    useEffect(() => {
        if (!profileLoading && profileData) {
            const getWhatsappProfile = !!profileData ? profileData.getWhatsappProfile : undefined;
            const assignedUsername = !!getWhatsappProfile && !!getWhatsappProfile.edges &&
            !!getWhatsappProfile.edges[0] && !!getWhatsappProfile.edges[0].node && !!getWhatsappProfile.edges[0].node.assignedTo ?
                getWhatsappProfile.edges[0].node.assignedTo.username : undefined;
            if (assignedUsername != userName) {
                setIsAssignToMeVisible(true);
            }
        }
    }, [profileLoading]);

    const [assignWhatsAppProfileToUserMutation] = useMutation(ASSIGN_WHATSAPP_PROFILE_TO_USER, {
        client: whatsAppClient
    });

    const assignWhatsAppProfileToUser = () => {
        assignWhatsAppProfileToUserMutation({
            variables: {
                mobileNumber: phoneNumber
            }
        }).then((resData) => {
            resData = !!resData && !!resData.data ? resData.data : undefined;
            const assignedProfile = !!resData.assignWhatsappProfileToUser && !!resData.assignWhatsappProfileToUser.profile ?
                resData.assignWhatsappProfileToUser.profile : undefined;
            if (!!assignedProfile && !!assignedProfile.assignedTo && assignedProfile.assignedTo.username === userName) {
                setIsAssignToMeVisible(false);
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        const spinny_token = localStorage.getItem(SPINNY_WEB_TOKEN);
        if(!spinny_token) {
            setErrorState({message: "User not authenticated, Please login again."})
        }
        setLoadingState(false)
    }, []);

    const {data, loading, refetch, fetchMore, error} = useQuery(GET_WHATSAPP_CONVERSATION, {
        client: whatsAppClient,
        variables: {
            contactNumber: phoneNumber,
            last: 25
        },
        fetchPolicy: "network-only"
    });

    const [markAsReadMutation] = useMutation(MARK_AS_READ, {
        client: whatsAppClient
    });

    useEffect(() => {
        if (!loading && data) {
            const messages = !!data.getMessages && !!data.getMessages.edges ? data.getMessages.edges : [];
            const messageId = messages.length > 0 ? messages[messages.length - 1].node.pk : null;
            if (!!messageId) {
                markAsReadMutation({
                    variables: {
                        messageId
                    }
                }).then((resData) => {
                    console.log(resData);
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }, [loading]);

    const [sendMessageMutation] = useMutation(WHATSAPP_SEND_MESSAGE, {
        client: whatsAppClient
    });

    const onSendMessage = (message) => {
        sendMessageMutation({ variables: {
            mobileNumber: phoneNumber,
            message
        }}).then((resData) => {
            // console.log(resData);
            onReload()
        });
    };

    const onReload = () => {
        setNewWhatsAppMessage([]);
        refetch({
            contactNumber: phoneNumber,
            last: 25
        });
    };

    const handleNewMessage = (newMessage) => {
        if (!!newMessage && !!newMessage.data) {
            const newMessageData = newMessage.data;
            const newMessageObj = {
                id: newMessageData.id,
                messageId: newMessageData.message_id,
                messageType: newMessageData.message_type,
                mobileNumber: newMessageData.mobile_number,
                pk: newMessageData.id,
                seenTime: null,
                sentTime: null,
                text: newMessageData.text,
                timeCreate: newMessageData.time_create,
                type: newMessageData.type,
                url: newMessageData.url,
                __typename: "WhatsAppMessageType"
            };
            setNewWhatsAppMessage(prevState => [...prevState, newMessageObj]);
        }
    }
    useEffect(() => {
        const chatChannel = pusher.subscribe("whatsapp-number-"+getSanitiseNumber(phoneNumber));
        chatChannel.bind("pusher:subscription_succeeded", () => {
            chatChannel.bind("message_received", (newMessage) => {
                handleNewMessage(newMessage);
            });
        });
        return () => {
            pusher.unsubscribe("whatsapp-number-" + getSanitiseNumber(phoneNumber));
        };
    }, []);

    const onClose = () => {
        console.log("Close");
    };

    const onLoadMore = () => {
        const pageInfo = data.getMessages.pageInfo;
        if (!pageInfo.hasPreviousPage)
            return null;

        fetchMore({
            variables: {
                before: pageInfo.startCursor,
            },
            updateQuery: (prev, {fetchMoreResult}) => {
                setLoadingMore(true);
                // @ts-ignore
                const prevData = prev.getMessages.edges;
                // @ts-ignore
                const newData = fetchMoreResult.getMessages.edges;
                const mergedData = [...newData, ...prevData];
                // @ts-ignore
                const updatedMessages = {...fetchMoreResult.getMessages, edges: mergedData};
                return Object.assign({}, {getMessages: updatedMessages});
            }
        }).catch(e => {
            console.log(e.message);
        }).finally(() => setLoadingMore(false))
    };

    return(
        chatBox({messageData: [...!!data ? data.getMessages.edges.map((chatData) => {
            return chatData.node
        }) : [], ...newWhatsAppMessage].reverse(),  onSendMessage, onReload, onClose, onLoadMore, loading: loading || loadingState,
            loadingMore, error: errorState ? errorState : error, isAssignToMeVisible, assignWhatsAppProfileToUser})
    );
};

export default WhatsAppDataComponent;